class SiteHead {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        this.navToggle();
        this.dropdownToggle();
        this.isScrolled();
    }

    navToggle() {
        const toggle = document.querySelector('[data-nav-toggle]');
        const html = document.getElementsByTagName("HTML")[0];
        const nav = document.getElementById('navItems');

        toggle.addEventListener('click', function() {
            toggle.classList.toggle('is-open');
            html.classList.toggle('overflow-hidden');
            nav.classList.toggle('d-none');
        });
    }

    dropdownToggle() {
        // const card = document.querySelector('[data-card-item]');
        const dropdowns = document.querySelectorAll('[data-dropdown-toggle]');
        const dropdownItems = document.querySelectorAll('[data-dropdown-item]');

        dropdowns.forEach(function (dropdown) {
            dropdown.addEventListener('click', function() {
                dropdowns.forEach(function (inner) {
                    inner.classList.remove('is-active');
                });

                // card.classList.remove('is-active');
                dropdown.classList.add('is-active');

                dropdownItems.forEach(function (item) {
                    item.classList.remove('is-active');

                    if (dropdown.dataset.dropdownToggleCount === item.dataset.dropdownItemCount) {
                        item.classList.add('is-active');
                    } else {
                        item.classList.remove('is-active');
                    }
                });
            });
        });
    }

    isScrolled() {
        const toggle = document.querySelector('[data-nav-toggle]');

        window.onscroll = function (e) {
            if (scrollY > 0) {
                toggle.classList.add('is-fixed');
            } else {
                toggle.classList.remove('is-fixed');
            }
        }
    }
}

export default SiteHead;
